import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function TestimonialsPage() {
  const testimonials = [
    {
      name: 'Jérôme Kokou',
      program: 'Ingénierie Mécanique',
      destination: 'France',
      university: 'École Centrale de Lyon',
      image: 'https://public.readdy.ai/ai/img_res/91b9bb6a695573facaa3395e1ea27dc8.jpg',
      quote: 'Grâce à EduGlobe Campus, j\'ai intégré une grande école en France. Accompagnement parfait du début à la fin. Leur expertise m\'a permis d\'éviter toutes les erreurs courantes et de maximiser mes chances d\'admission.',
      rating: 5,
      year: '2023'
    },
    {
      name: 'Sandra Amegah',
      program: 'Management International',
      destination: 'Canada',
      university: 'HEC Montréal',
      image: 'https://readdy.ai/api/search-image?query=Professional%20young%20African%20female%20business%20student%20smiling%20confident%20portrait%20university%20campus%20background%20modern%20setting%20bright%20natural%20lighting%20success%20story%20educational%20achievement%20simple%20clean%20background&width=400&height=400&seq=student-sandra-1&orientation=squarish',
      quote: 'Sans leur soutien, je n\'aurais jamais obtenu mon visa canadien dans les délais. L\'équipe d\'EduGlobe Campus a été exceptionnelle, professionnelle et toujours disponible pour répondre à mes questions.',
      rating: 5,
      year: '2023'
    },
    {
      name: 'Koffi Mensah',
      program: 'Sciences Informatiques',
      destination: 'Belgique',
      university: 'Université Catholique de Louvain',
      image: 'https://readdy.ai/api/search-image?query=Professional%20young%20African%20male%20computer%20science%20student%20smiling%20confident%20portrait%20university%20campus%20background%20modern%20technology%20setting%20bright%20natural%20lighting%20success%20story%20educational%20achievement%20simple%20clean%20background&width=400&height=400&seq=student-koffi-1&orientation=squarish',
      quote: 'Le processus était clair et bien structuré. J\'ai apprécié la transparence et le professionnalisme de toute l\'équipe. Aujourd\'hui, je suis épanoui dans mes études en Belgique grâce à leur accompagnement.',
      rating: 5,
      year: '2024'
    },
    {
      name: 'Afi Dzogbede',
      program: 'Médecine',
      destination: 'France',
      university: 'Université de Strasbourg',
      image: 'https://readdy.ai/api/search-image?query=Professional%20young%20African%20female%20medical%20student%20smiling%20confident%20portrait%20university%20hospital%20background%20modern%20healthcare%20setting%20bright%20natural%20lighting%20success%20story%20educational%20achievement%20simple%20clean%20background&width=400&height=400&seq=student-afi-1&orientation=squarish',
      quote: 'Mon rêve de devenir médecin en France est devenu réalité grâce à EduGlobe Campus. Leur connaissance du système français et leur réseau m\'ont ouvert des portes que je n\'aurais jamais imaginées.',
      rating: 5,
      year: '2023'
    },
    {
      name: 'Edem Agbeko',
      program: 'Finance et Comptabilité',
      destination: 'Canada',
      university: 'Université de Toronto',
      image: 'https://readdy.ai/api/search-image?query=Professional%20young%20African%20male%20finance%20student%20smiling%20confident%20portrait%20university%20campus%20background%20modern%20business%20setting%20bright%20natural%20lighting%20success%20story%20educational%20achievement%20simple%20clean%20background&width=400&height=400&seq=student-edem-1&orientation=squarish',
      quote: 'L\'accompagnement personnalisé m\'a vraiment fait la différence. Chaque étape était bien expliquée et je me sentais soutenu tout au long du processus. Je recommande vivement leurs services.',
      rating: 5,
      year: '2024'
    },
    {
      name: 'Akossiwa Togo',
      program: 'Architecture',
      destination: 'Belgique',
      university: 'Université Libre de Bruxelles',
      image: 'https://readdy.ai/api/search-image?query=Professional%20young%20African%20female%20architecture%20student%20smiling%20confident%20portrait%20university%20campus%20background%20modern%20design%20setting%20bright%20natural%20lighting%20success%20story%20educational%20achievement%20simple%20clean%20background&width=400&height=400&seq=student-akossiwa-1&orientation=squarish',
      quote: 'De la sélection de l\'université jusqu\'à mon installation à Bruxelles, EduGlobe Campus a été présent à chaque étape. Leur suivi post-arrivée m\'a beaucoup aidé à m\'adapter rapidement.',
      rating: 5,
      year: '2024'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <section className="bg-gradient-to-r from-[#003D82] to-[#0052AD] text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-6">Témoignages</h1>
          <div className="w-24 h-1 bg-[#FF6B35] mb-6"></div>
          <p className="text-xl max-w-4xl leading-relaxed text-white/90">
            Découvrez les histoires inspirantes de nos étudiants qui ont réalisé leur rêve d'études à l'étranger avec l'accompagnement d'EduGlobe Campus.
          </p>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div 
                key={index}
                className="bg-white border-2 border-gray-100 rounded-2xl overflow-hidden hover:border-[#FF6B35] hover:shadow-2xl transition-all"
              >
                <div className="p-6">
                  <div className="flex items-center gap-4 mb-4">
                    <img 
                      src={testimonial.image}
                      alt={`${testimonial.name} - Étudiant EduGlobe Campus`}
                      title={testimonial.name}
                      className="w-20 h-20 rounded-full object-cover border-4 border-[#FF6B35]/20"
                    />
                    <div>
                      <h3 className="text-xl font-bold text-[#003D82]">{testimonial.name}</h3>
                      <div className="flex text-[#FF6B35] text-sm">
                        {[...Array(testimonial.rating)].map((_, i) => (
                          <i key={i} className="ri-star-fill"></i>
                        ))}
                      </div>
                    </div>
                  </div>

                  <div className="mb-4">
                    <div className="flex items-center text-sm text-gray-600 mb-1">
                      <i className="ri-book-open-fill text-[#FF6B35] mr-2"></i>
                      <span className="font-semibold">{testimonial.program}</span>
                    </div>
                    <div className="flex items-center text-sm text-gray-600 mb-1">
                      <i className="ri-building-fill text-[#FF6B35] mr-2"></i>
                      <span>{testimonial.university}</span>
                    </div>
                    <div className="flex items-center text-sm text-gray-600">
                      <i className="ri-map-pin-fill text-[#FF6B35] mr-2"></i>
                      <span>{testimonial.destination} • {testimonial.year}</span>
                    </div>
                  </div>

                  <div className="relative">
                    <i className="ri-double-quotes-l text-4xl text-[#FF6B35]/20 absolute -top-2 -left-2"></i>
                    <p className="text-gray-700 leading-relaxed italic pl-6">
                      {testimonial.quote}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-xl p-12">
            <div className="text-center mb-12">
              <h2 className="text-4xl font-bold text-[#003D82] mb-4">Nos résultats en chiffres</h2>
              <div className="w-24 h-1 bg-[#FF6B35] mx-auto"></div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="text-5xl font-bold text-[#FF6B35] mb-2">500+</div>
                <div className="text-gray-600 font-medium">Étudiants accompagnés</div>
              </div>
              <div className="text-center">
                <div className="text-5xl font-bold text-[#FF6B35] mb-2">95%</div>
                <div className="text-gray-600 font-medium">Taux d'admission</div>
              </div>
              <div className="text-center">
                <div className="text-5xl font-bold text-[#FF6B35] mb-2">92%</div>
                <div className="text-gray-600 font-medium">Taux d'obtention visa</div>
              </div>
              <div className="text-center">
                <div className="text-5xl font-bold text-[#FF6B35] mb-2">98%</div>
                <div className="text-gray-600 font-medium">Satisfaction client</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#003D82] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Rejoignez nos étudiants à succès</h2>
          <p className="text-xl mb-8 text-white/90">
            Votre histoire de réussite commence ici. Laissez-nous vous accompagner vers l'excellence académique.
          </p>
          <button
            onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
            className="bg-[#FF6B35] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#FF6B35]/90 transition-all shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center"
          >
            <i className="ri-calendar-check-fill mr-3 text-2xl"></i>
            Commencer mon projet
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
}
